import { render, staticRenderFns } from "./VasionFilterToggle.vue?vue&type=template&id=60d0ecf3&scoped=true&"
import script from "./VasionFilterToggle.vue?vue&type=script&lang=js&"
export * from "./VasionFilterToggle.vue?vue&type=script&lang=js&"
import style0 from "./VasionFilterToggle.vue?vue&type=style&index=0&id=60d0ecf3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d0ecf3",
  null
  
)

export default component.exports